var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.0625 26.3657L69.125 11.5532C68.9532 11.0422 68.6189 10.6015 68.1731 10.2984C67.7274 9.99524 67.1946 9.84635 66.6562 9.87445H12.3438C11.8054 9.84635 11.2727 9.99524 10.8269 10.2984C10.3811 10.6015 10.0468 11.0422 9.875 11.5532L4.9375 26.3657C4.90194 26.6278 4.90194 26.8936 4.9375 27.1557V41.9682C4.9375 42.623 5.1976 43.2509 5.66058 43.7139C6.12356 44.1769 6.7515 44.437 7.40625 44.437H9.875V69.1245H14.8125V44.437H29.625V69.1245H69.125V44.437H71.5938C72.2485 44.437 72.8764 44.1769 73.3394 43.7139C73.8024 43.2509 74.0625 42.623 74.0625 41.9682V27.1557C74.0981 26.8936 74.0981 26.6278 74.0625 26.3657ZM64.1875 64.187H34.5625V44.437H64.1875V64.187ZM69.125 39.4995H59.25V29.6245H54.3125V39.4995H41.9688V29.6245H37.0312V39.4995H24.6875V29.6245H19.75V39.4995H9.875V27.5507L14.1213 14.812H64.8787L69.125 27.5507V39.4995Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.a63b355e96e9e760415e9549f88ffc54.svg";
export { ForwardRef as ReactComponent };